import React, { useState, useEffect, useCallback } from 'react';
import { connect } from 'react-redux';


const DropdownTreeSelectBox = (props: any) => {
    
    let dataItem = (props.value.Response != null && props.value.Response != undefined) ? props.value.Response : props.newval;
    
    let dataList = null;
    let onLoadList = null;
    let [breadcrumb, setBreadcrumb] = useState([{ KEY: "", LABEL: "All", HLEVEL: "H0" }] as any);
    let [searchString, setSearchString] = useState([{ SearchString: "" }] as any);
    let [itemPath, setItemPath] = useState([""] as any);
    let [itemKey, setItemKey] = useState([""] as any);
    let [isDisabled, setIsDisabled] = useState(false);
    let [displayValue, setdisplayValue] = useState("");
    let [searchValue, setsearchValue] = useState("");
    let [data, setData] = useState([]);

    let arangeBreadcrumb = (item: any) => {
        var newitem = item;
        setBreadcrumb((breadcrumb: any) => ([
            ...breadcrumb,
            newitem
        ]))
        var newLabel = item.LABEL;
        setItemPath((itemPath: any) => ([
            ...itemPath,
            newLabel
        ]))
        var newKey = item.KEY;
        setItemKey((itemKey: any) => ([
            ...itemKey,
            newKey
        ]))

    }

    useEffect(() => {
        //const commaSep = itemPath.map((item: any) => item).join('|');
        //console.log(commaSep);
        let itemSet = [[]]
        itemSet = [displayValue, itemKey];
        props.onSelectClick(itemSet);
        if (dataItem && dataItem.length == 0) {
            setIsDisabled(true);
        }
        newSearch();
    }, [searchValue,displayValue, itemPath, itemKey, dataItem]);

    let clearAll = () => {
        breadcrumb.length = 1;
        props.onSelectChange(breadcrumb[0]);
        setItemPath([""]);
        setItemKey([""]);
        setIsDisabled(false);
        setsearchValue('');
    };

    let clearAllOnSelect = () => {
        breadcrumb.length = 1;
        props.onSelectChange(breadcrumb[0]);
        setIsDisabled(false);
        setsearchValue('');
    };

    let onBreadcrumbClick = (i: any) => {
        breadcrumb.length = i + 1;
        itemPath.length = i;
        itemKey.length = i;
        setIsDisabled(false);
    }

    let getPrevious = () => {
        var currentLen = breadcrumb.length;
        setIsDisabled(false);
        if (currentLen > 1) {
            var newLength = currentLen - 1;
            var previousItem = breadcrumb[newLength - 1];
            props.onSelectChange(previousItem);
            breadcrumb.length = newLength;
            itemPath.length = newLength - 1;
            itemKey.length = newLength - 1;

        }
    }

    useEffect(() => {
        if (dataItem && dataItem.length == 0) {
            lastChildData();
        }

    }, [dataItem])

    let lastChildData = () => {
        if (itemPath.length > 0) {
        var itemListLen = breadcrumb.length;
        var preItem = breadcrumb[itemListLen - 2];
        props.onSelectChange(preItem);
        breadcrumb.length = breadcrumb.length - 1;
        itemPath.length = itemListLen - 2;
        itemKey.length = itemListLen - 2;
        }
        
    }

    let onLabelClick = (item: any) => {
        if (isDisabled == false) {
            arangeBreadcrumb(item);
            props.onSelectChange(item);
        }
    }

    let onSelectClick = (item: any) => {

        var newLabel = item.LABEL;
        setItemPath((itemPath: any) => ([
            ...itemPath,
            newLabel
        ]));
        setdisplayValue(newLabel);

        var newKey = item.KEY;
        setItemKey((itemKey: any) => ([
            ...itemKey,
            newKey
        ]))
        /*props.onSelectClick(itemPath)*/
    }

    let onSearchClick = (e: any) => {
        props.onSelectChange(searchString);
    }
    let newSearch = () => {
        //setsearchValue(e.target.value);
        setSearchString((prevState: any) => ({
            SearchString: searchValue
        }));
    }


    let resetOnAddClick = () => {
        (async () => {
            const apiURL = props.url;
            const rawResponse = await fetch(apiURL, {
                method: 'POST',
                headers: {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify({ HLEVEL: "H0" })
            });
            const content = await rawResponse.json();
            setData(content.Response);
        })();
        setItemPath('');
        setItemKey('');
        setsearchValue('');
        setIsDisabled(false)
    }



    dataList = dataItem && dataItem.length > 0 ?
        dataItem.map((item: any, i: any) => {
            return (
                <div className="mydivouter">
                    <i className="fa fa-folder"></i><span style={{ cursor: 'pointer' }} className="pl-2" key={i} onClick={(e) => { onLabelClick(item); }}>{item.LABEL}</span>
                    <button type="button" disabled={item.ENABLE.toLowerCase() === 'false' ? true : false} onClick={(e) => { onSelectClick(item); clearAllOnSelect(); }} data-dismiss="modal" className="mybuttonoverlap btn btn-primary">Select</button>
                </div>
            )
        }) : '';

    onLoadList = data && data.length > 0 ?
        data.map((item: any, i: any) => {
            return (
                <div className="mydivouter">
                    <i className="fa fa-folder"></i><span style={{ cursor: 'pointer' }} className="pl-2" key={i} onClick={(e) => { onLabelClick(item); }}>{item.LABEL}</span>
                    <button type="button" disabled={item.ENABLE.toLowerCase() === 'false' ? true : false} onClick={(e) => { onSelectClick(item); clearAllOnSelect(); }} data-dismiss="modal" className="mybuttonoverlap btn btn-primary">Select</button>
                </div>
            )
        }) : '';
            

    const newBreadcrumb = breadcrumb.map((itemnew: any, i: any) => {
        return (
            <span key={i} style={{ cursor: 'pointer', marginRight: '12px' }} onClick={(e) => { onBreadcrumbClick(i); props.onSelectChange(itemnew); }}>  { itemnew.LABEL} / </span>
        )
    });

    return (
        <>
            <div className="">
                <button type="button" onClick={(e) => { resetOnAddClick() }} className="btn btn-primary dds__button dds__button dds__button--secondary dds__button--md dds__ml-2 dds__halo-add-button" data-toggle="modal" data-target={"#staticBackdrop" + props.num}>
                    + Add
                </button>

                <div className="modal fade" id={"staticBackdrop" + props.num} data-backdrop="static" data-keyboard="false" aria-labelledby="staticBackdropLabel" aria-hidden="true">
                    <div className="modal-dialog">
                        <div className="halo-popup">
                            <div className="modal-content">
                                <div className="modal-header">
                                    <div className="dds__d-flex">
                                        <div className="dds__col-md-12 dds__pl-0 dds__pr-0 dds__mr-0 dds__ml-0">
                                            <h5 className="modal-title" id="staticBackdropLabel">{props.title}</h5>
                                        </div>
                                        <div className="dds__pull-right " data-dismiss="modal" onClick={(e) => { clearAll() }} aria-label="Close">
                                            <div className="dds__close dds__pull-right  ">
                                                <i className="dds__icons dds__pl-0  dds__close-x dds__button__icon--left dds__close"></i></div> </div>
                                    </div>
                                </div>
                                <div className="modal-body dds__pl-0 dds__ml-0 dds__mr-0 dds__pr-0">
                                    <div className="dds__col-md-12 dds__pl-0 dds__ml-0 dds__mr-0 dds__pr-0 dds__halopopup">
                                        <div className="dds__p-3 border-bottom">{newBreadcrumb}</div>
                                        <div className="input-group dds__ml-2">
                                            <input type="text" className="form-control" value={searchValue} placeholder="Search" onChange={(e: any) => { setsearchValue(e.target.value) }} />
                                            <div className="input-group-append">
                                                <button className="btn btn-secondary" type="button" onClick={(e) => { onSearchClick(e); }}>
                                                    <i className="fa fa-search"></i>
                                                </button>
                                            </div>
                                        </div>
                                        <div className="dds__col-md-12">
                                            <div className="pb-3 pt-3 pull-left" style={{ cursor: 'pointer' }} onClick={(e) => { getPrevious() }}><i className="dds__icons dds__mt-1 pull-left dds__arrow-cir-up dds__button__icon--left dds__mr-2"></i>Go back to the previous level</div><br /><br /><br />
                                            {/*{dataList !== null && dataList.length > 0 ? dataList : "No Child Data Available"}*/}
                                            {dataList ? dataList : onLoadList}
                                        </div>
                                        <div className="modal-footer">
                                            <button type="button" className="dds__button dds__button--primary dds__button--sm"><i className="dds__icons  dds__check dds__button__icon--left dds__pr-2"></i>OK</button>
                                            <button type="button" className="dds__button dds__button--secondary dds__button--sm" onClick={(e) => { clearAll() }} data-dismiss="modal"><i className="dds__pr-2 dds__icons  dds__close-x dds__button__icon--left"></i> Cancel</button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
};
export default connect()(DropdownTreeSelectBox);